// 3rd party
import * as React from "react";
import { Box, Button, Tooltip, Typography } from "@material-ui/core";
import { ExitToApp } from "@material-ui/icons";

// Domain
import * as domain from "@src/domain";

// Styles
import { useUserAreaStyles } from "./styles";

export { UserArea };

interface UserAreaProps {
	user: domain.User;
	quantities: domain.ProductQuantities;
	onLogout: () => void;
	isDrawerOpen: boolean;
}

function UserArea({
	user,
	quantities,
	onLogout,
	isDrawerOpen,
}: UserAreaProps): JSX.Element {
	const classes = useUserAreaStyles();

	return isDrawerOpen ? (
		<Box className={classes.userArea}>
			<Box>
				<img
					className={classes.userAreaImage}
					src={user.avatar}
					alt="Profile avatar"
				/>
			</Box>
			<Typography className={classes.userAreaName}>{user.username}</Typography>
			<Box className={classes.userAreaDetails}>
				<Box>
					<Typography className={classes.userAreaDetailHeader}>
						{quantities.modelQuantity}
					</Typography>
					<Typography className={classes.userAreaDetailTagline}>
						Models
					</Typography>
				</Box>
				<Box>
					<Typography className={classes.userAreaDetailHeader}>
						{quantities.deviceQuantity}
					</Typography>
					<Typography className={classes.userAreaDetailTagline}>
						Devices
					</Typography>
				</Box>
			</Box>
			<Button className={classes.logoutButton} onClick={onLogout}>
				Logout
			</Button>
		</Box>
	) : (
		<Box className={classes.userAreaSmall}>
			<Tooltip title="Log out" placement="right">
				<Button className={classes.logoutButtonSmall} onClick={onLogout}>
					<ExitToApp />
				</Button>
			</Tooltip>
		</Box>
	);
}
